var map = {
	"./360ONE.png": 94124,
	"./3MINDIA.png": 51077,
	"./AADHARHFC.png": 13492,
	"./AARTIIND.png": 91635,
	"./AAVAS.png": 84716,
	"./ABB.png": 64318,
	"./ABBOTINDIA.png": 59860,
	"./ABCAPITAL.png": 67699,
	"./ABFRL.png": 2115,
	"./ABLBL.png": 7897,
	"./ABREL.png": 37399,
	"./ABSLAMC.png": 94603,
	"./ACC.png": 32063,
	"./ACE.png": 72797,
	"./ACMESOLAR.png": 8109,
	"./ADANIENSOL.png": 98513,
	"./ADANIENT.png": 73016,
	"./ADANIGREEN.png": 94678,
	"./ADANIPORTS.png": 33563,
	"./ADANIPOWER.png": 67206,
	"./ADANITRANS.png": 97213,
	"./AEGISLOG.png": 65210,
	"./AEGISVOPAK.png": 14353,
	"./AFCONS.png": 34137,
	"./AFFLE.png": 93343,
	"./AGARWALEYE.png": 35967,
	"./AIAENG.png": 27524,
	"./AIIL.png": 30863,
	"./AJANTPHARM.png": 69612,
	"./AKUMS.png": 80661,
	"./AKZOINDIA.png": 87388,
	"./ALIVUS.png": 54050,
	"./ALKEM.png": 8570,
	"./ALKYLAMINE.png": 80035,
	"./ALOKINDS.png": 42666,
	"./AMBER.png": 47284,
	"./AMBUJACEM.png": 21067,
	"./ANANDRATHI.png": 97452,
	"./ANANTRAJ.png": 39780,
	"./ANGELONE.png": 94081,
	"./APARINDS.png": 23175,
	"./APLAPOLLO.png": 82690,
	"./APLLTD.png": 84282,
	"./APOLLOHOSP.png": 92537,
	"./APOLLOTYRE.png": 80090,
	"./APTUS.png": 90780,
	"./ARE&M.png": 59127,
	"./ASAHIINDIA.png": 6816,
	"./ASHOKLEY.png": 15654,
	"./ASIANPAINT.png": 19135,
	"./ASTERDM.png": 9897,
	"./ASTRAL.png": 36319,
	"./ASTRAZEN.png": 2165,
	"./ATGL.png": 77763,
	"./ATHERENERG.png": 63578,
	"./ATUL.png": 44839,
	"./AUBANK.png": 42699,
	"./AUROPHARMA.png": 43282,
	"./AWL.png": 67543,
	"./AXISBANK.png": 28982,
	"./BAJAJ-AUTO.png": 20386,
	"./BAJAJFINSV.png": 69268,
	"./BAJAJHFL.png": 67234,
	"./BAJAJHLDNG.png": 81088,
	"./BAJFINANCE.png": 73855,
	"./BAKISIND.png": 73158,
	"./BALKRISIND.png": 23922,
	"./BALRAMCHIN.png": 7573,
	"./BANDHANBNK.png": 53661,
	"./BANKBARODA.png": 61277,
	"./BANKINDIA.png": 44944,
	"./BASF.png": 58986,
	"./BATAINDIA.png": 27448,
	"./BAYERCROP.png": 74124,
	"./BBTC.png": 84974,
	"./BDL.png": 11242,
	"./BEL.png": 96726,
	"./BEML.png": 13277,
	"./BERGEPAINT.png": 5175,
	"./BHARATFORG.png": 79129,
	"./BHARTIARTL.png": 57705,
	"./BHARTIHEXA.png": 89235,
	"./BHEL.png": 80889,
	"./BIKAJI.png": 33737,
	"./BIOCON.png": 11189,
	"./BLS.png": 27847,
	"./BLUEDART.png": 56248,
	"./BLUEJET.png": 59682,
	"./BLUESTARCO.png": 71211,
	"./BOSCHLTD.png": 67445,
	"./BPCL.png": 52126,
	"./BRIGADE.png": 56075,
	"./BRITANNIA.png": 27815,
	"./BSE.png": 83550,
	"./BSOFT.png": 90486,
	"./CAMPUS.png": 54256,
	"./CAMS.png": 99497,
	"./CANBK.png": 74721,
	"./CANFINHOME.png": 31510,
	"./CAPLIPOINT.png": 15107,
	"./CARBORUNIV.png": 45361,
	"./CASTROLIND.png": 1476,
	"./CCL.png": 64972,
	"./CDSL.png": 3473,
	"./CEATLTD.png": 90465,
	"./CENTRALBK.png": 44487,
	"./CENTURYPLY.png": 29949,
	"./CERA.png": 10403,
	"./CESC.png": 23616,
	"./CGCL.png": 36863,
	"./CGPOWER.png": 21721,
	"./CHALET.png": 18723,
	"./CHAMBLFERT.png": 91113,
	"./CHENNPETRO.png": 16512,
	"./CHOICEIN.png": 88962,
	"./CHOLAFIN.png": 26566,
	"./CHOLAHLDNG.png": 82902,
	"./CIPLA.png": 96464,
	"./CLEAN.png": 97946,
	"./COALINDIA.png": 90090,
	"./COCHINSHIP.png": 85874,
	"./COFORGE.png": 36529,
	"./COHANCE.png": 24989,
	"./COLPAL.png": 59235,
	"./CONCOR.png": 87383,
	"./CONCORDBIO.png": 27833,
	"./COROMANDEL.png": 27164,
	"./CRAFTSMAN.png": 30064,
	"./CREDITACC.png": 61316,
	"./CRISIL.png": 35275,
	"./CROMPTON.png": 99150,
	"./CUB.png": 31080,
	"./CUMMINSIND.png": 25278,
	"./CYIENT.png": 96905,
	"./DABUR.png": 91953,
	"./DALBHARAT.png": 92703,
	"./DATAPATTNS.png": 5949,
	"./DBREALTY.png": 18378,
	"./DCMSHRIRAM.png": 7439,
	"./DEEPAKFERT.png": 99098,
	"./DEEPAKNTR.png": 82702,
	"./DELHIVERY.png": 56647,
	"./DEVYANI.png": 79468,
	"./DIVISLAB.png": 61196,
	"./DIXON.png": 28094,
	"./DLF.png": 97627,
	"./DMART.png": 11764,
	"./DOMS.png": 59459,
	"./DRREDDY.png": 34187,
	"./DUMMYDBRLT.png": 17097,
	"./DUMMYHDLVR.png": 38262,
	"./DUMMYSIEMS.png": 97325,
	"./ECLERX.png": 80759,
	"./EICHERMOT.png": 21338,
	"./EIDPARRY.png": 91057,
	"./EIHOTEL.png": 58700,
	"./ELECON.png": 36041,
	"./ELGIEQUIP.png": 38963,
	"./EMAMILTD.png": 79873,
	"./EMCURE.png": 10498,
	"./ENDURANCE.png": 7316,
	"./ENGINERSIN.png": 53437,
	"./ENRIN.png": 60408,
	"./ERIS.png": 31587,
	"./ESCORTS.png": 95206,
	"./ETERNAL.png": 93456,
	"./EXIDEIND.png": 75584,
	"./FACT.png": 85926,
	"./FEDERALBNK.png": 55791,
	"./FINCABLES.png": 35599,
	"./FINPIPE.png": 79275,
	"./FIRSTCRY.png": 38553,
	"./FIVESTAR.png": 71929,
	"./FLUOROCHEM.png": 81261,
	"./FORCEMOT.png": 3472,
	"./FORTIS.png": 50540,
	"./FSL.png": 94985,
	"./GAIL.png": 69276,
	"./GESHIP.png": 88667,
	"./GICRE.png": 16505,
	"./GILLETTE.png": 16679,
	"./GLAND.png": 83869,
	"./GLAXO.png": 5987,
	"./GLENMARK.png": 26399,
	"./GMDCLTD.png": 8644,
	"./GMRAIRPORT.png": 66119,
	"./GODFRYPHLP.png": 94163,
	"./GODIGIT.png": 49440,
	"./GODREJAGRO.png": 52377,
	"./GODREJCP.png": 13052,
	"./GODREJIND.png": 81578,
	"./GODREJPROP.png": 20140,
	"./GPIL.png": 59098,
	"./GRANULES.png": 52493,
	"./GRAPHITE.png": 93768,
	"./GRASIM.png": 22465,
	"./GRAVITA.png": 47555,
	"./GRSE.png": 63697,
	"./GSPL.png": 51786,
	"./GUJGASLTD.png": 42500,
	"./GVT&D.png": 70345,
	"./HAL.png": 32009,
	"./HAPPSTMNDS.png": 78796,
	"./HAVELLS.png": 78790,
	"./HBLENGINE.png": 1824,
	"./HCLTECH.png": 37556,
	"./HDFC.png": 30271,
	"./HDFCAMC.png": 62568,
	"./HDFCBANK.png": 784,
	"./HDFCLIFE.png": 86105,
	"./HEG.png": 23846,
	"./HEROMOTOCO.png": 32152,
	"./HEXT.png": 8294,
	"./HFCL.png": 8901,
	"./HINDALCO.png": 27253,
	"./HINDCOPPER.png": 12708,
	"./HINDPETRO.png": 82974,
	"./HINDUNILVR.png": 1280,
	"./HINDZINC.png": 75931,
	"./HOMEFIRST.png": 24826,
	"./HONASA.png": 41956,
	"./HONAUT.png": 57164,
	"./HSCL.png": 63073,
	"./HUDCO.png": 51380,
	"./HYUNDAI.png": 52510,
	"./ICICIBANK.png": 65422,
	"./ICICIGI.png": 35639,
	"./ICICIPRULI.png": 32593,
	"./IDBI.png": 29743,
	"./IDEA.png": 56995,
	"./IDFCFIRSTB.png": 75814,
	"./IEX.png": 14326,
	"./IFCI.png": 7928,
	"./IGIL.png": 52960,
	"./IGL.png": 47005,
	"./IIFL.png": 67389,
	"./IKS.png": 47657,
	"./INDGN.png": 36856,
	"./INDHOTEL.png": 80270,
	"./INDIACEM.png": 63522,
	"./INDIAMART.png": 80557,
	"./INDIANB.png": 25670,
	"./INDIGO.png": 34011,
	"./INDUSINDBK.png": 34838,
	"./INDUSTOWER.png": 76284,
	"./INFY.png": 23328,
	"./INOXINDIA.png": 3225,
	"./INOXWIND.png": 54288,
	"./INTELLECT.png": 89448,
	"./IOB.png": 18407,
	"./IOC.png": 85061,
	"./IPCALAB.png": 14379,
	"./IRB.png": 49966,
	"./IRCON.png": 27688,
	"./IRCTC.png": 60780,
	"./IREDA.png": 57260,
	"./IRFC.png": 14312,
	"./ITC.png": 96208,
	"./ITCHOTELS.png": 15530,
	"./ITI.png": 32043,
	"./J&KBANK.png": 96152,
	"./JBCHEPHARM.png": 73178,
	"./JBMA.png": 88460,
	"./JINDALSAW.png": 15757,
	"./JINDALSTEL.png": 70683,
	"./JIOFIN.png": 67427,
	"./JKCEMENT.png": 80141,
	"./JKTYRE.png": 17025,
	"./JMFINANCIL.png": 78224,
	"./JPPOWER.png": 83669,
	"./JSL.png": 17572,
	"./JSWENERGY.png": 22305,
	"./JSWINFRA.png": 10997,
	"./JSWSTEEL.png": 59135,
	"./JUBLFOOD.png": 14019,
	"./JUBLINGREA.png": 1816,
	"./JUBLPHARMA.png": 75262,
	"./JWL.png": 37009,
	"./JYOTHYLAB.png": 929,
	"./JYOTICNC.png": 81079,
	"./KAJARIACER.png": 71209,
	"./KALYANKJIL.png": 47857,
	"./KARURVYSYA.png": 68363,
	"./KAYNES.png": 43484,
	"./KEC.png": 7555,
	"./KEI.png": 8409,
	"./KFINTECH.png": 87134,
	"./KIMS.png": 23938,
	"./KIRLOSBROS.png": 28274,
	"./KIRLOSENG.png": 80312,
	"./KOTAKBANK.png": 35142,
	"./KPIL.png": 66041,
	"./KPITTECH.png": 30317,
	"./KPRMILL.png": 34413,
	"./KSB.png": 48946,
	"./LALPATHLAB.png": 54352,
	"./LATENTVIEW.png": 76524,
	"./LAURUSLABS.png": 39061,
	"./LEMONTREE.png": 24516,
	"./LICHSGFIN.png": 89430,
	"./LICI.png": 48585,
	"./LINDEINDIA.png": 40582,
	"./LLOYDSME.png": 17661,
	"./LODHA.png": 77342,
	"./LT.png": 11183,
	"./LTF.png": 99955,
	"./LTFOODS.png": 38614,
	"./LTIM.png": 34297,
	"./LTTS.png": 48752,
	"./LUPIN.png": 93915,
	"./M&M.png": 69618,
	"./M&MFIN.png": 38763,
	"./MAHABANK.png": 32796,
	"./MAHSCOOTER.png": 13413,
	"./MAHSEAMLES.png": 64149,
	"./MANAPPURAM.png": 56377,
	"./MANKIND.png": 31616,
	"./MANYAVAR.png": 38182,
	"./MAPMYINDIA.png": 48407,
	"./MARICO.png": 41630,
	"./MARUTI.png": 3872,
	"./MAXHEALTH.png": 20288,
	"./MAZDOCK.png": 24707,
	"./MCX.png": 80534,
	"./MEDANTA.png": 19687,
	"./METROPOLIS.png": 23003,
	"./MFSL.png": 68657,
	"./MGL.png": 85559,
	"./MINDACORP.png": 76358,
	"./MMTC.png": 70723,
	"./MOTHERSON.png": 65362,
	"./MOTILALOFS.png": 41788,
	"./MPHASIS.png": 71629,
	"./MRF.png": 17802,
	"./MRPL.png": 3922,
	"./MSUMI.png": 84286,
	"./MUTHOOTFIN.png": 65553,
	"./NAM-INDIA.png": 99556,
	"./NATCOPHARM.png": 60921,
	"./NATIONALUM.png": 78452,
	"./NAUKRI.png": 20158,
	"./NAVA.png": 27625,
	"./NAVINFLUOR.png": 20931,
	"./NBCC.png": 2163,
	"./NCC.png": 40262,
	"./NESTLEIND.png": 74179,
	"./NETWEB.png": 53104,
	"./NEULANDLAB.png": 94871,
	"./NEWGEN.png": 58359,
	"./NH.png": 85697,
	"./NHPC.png": 68029,
	"./NIACL.png": 39452,
	"./NIVABUPA.png": 26555,
	"./NLCINDIA.png": 56825,
	"./NMDC.png": 18815,
	"./NSLNISP.png": 92841,
	"./NTPC.png": 33975,
	"./NTPCGREEN.png": 45142,
	"./NUVAMA.png": 96953,
	"./NUVOCO.png": 54035,
	"./NYKAA.png": 59475,
	"./OBEROIRLTY.png": 81477,
	"./OFSS.png": 81306,
	"./OIL.png": 10180,
	"./OLAELEC.png": 66146,
	"./OLECTRA.png": 84462,
	"./ONESOURCE.png": 5433,
	"./ONGC.png": 23942,
	"./PAGEIND.png": 20565,
	"./PATANJALI.png": 64419,
	"./PAYTM.png": 10055,
	"./PCBL.png": 16240,
	"./PERSISTENT.png": 3912,
	"./PETRONET.png": 87997,
	"./PFC.png": 13752,
	"./PFIZER.png": 76025,
	"./PGEL.png": 4750,
	"./PGHH.png": 72696,
	"./PHOENIXLTD.png": 80218,
	"./PIDILITIND.png": 9598,
	"./PIIND.png": 64665,
	"./PNB.png": 45365,
	"./PNBHOUSING.png": 69317,
	"./POLICYBZR.png": 54825,
	"./POLYCAB.png": 84019,
	"./POLYMED.png": 77167,
	"./POONAWALLA.png": 22775,
	"./POWERGRID.png": 60423,
	"./POWERINDIA.png": 11113,
	"./PPLPHARMA.png": 30752,
	"./PRAJIND.png": 79108,
	"./PREMIERENE.png": 53510,
	"./PRESTIGE.png": 46370,
	"./PTCIL.png": 73464,
	"./PVRINOX.png": 6735,
	"./RADICO.png": 30527,
	"./RAILTEL.png": 79398,
	"./RAINBOW.png": 73585,
	"./RAMCOCEM.png": 9006,
	"./RBLBANK.png": 99952,
	"./RCF.png": 95647,
	"./RECLTD.png": 95734,
	"./REDINGTON.png": 91999,
	"./RELIANCE.png": 53697,
	"./RELINFRA.png": 31872,
	"./RHIM.png": 92317,
	"./RITES.png": 53695,
	"./RKFORGE.png": 51797,
	"./RPOWER.png": 70899,
	"./RRKABEL.png": 95750,
	"./RVNL.png": 49635,
	"./SAGILITY.png": 47643,
	"./SAIL.png": 53337,
	"./SAILIFE.png": 94034,
	"./SAMMAANCAP.png": 76251,
	"./SAPPHIRE.png": 35065,
	"./SARDAEN.png": 64390,
	"./SAREGAMA.png": 25493,
	"./SBFC.png": 46162,
	"./SBICARD.png": 98095,
	"./SBILIFE.png": 73444,
	"./SBIN.png": 40614,
	"./SCHAEFFLER.png": 66551,
	"./SCHNEIDER.png": 69950,
	"./SCI.png": 24923,
	"./SHREECEM.png": 40261,
	"./SHRIRAMFIN.png": 16335,
	"./SHYAMMETL.png": 24847,
	"./SIEMENS.png": 64767,
	"./SIGNATURE.png": 11253,
	"./SJVN.png": 39466,
	"./SKFINDIA.png": 93438,
	"./SOBHA.png": 44682,
	"./SOLARINDS.png": 19111,
	"./SONACOMS.png": 40253,
	"./SONATSOFTW.png": 38005,
	"./SRF.png": 59216,
	"./STARHEALTH.png": 2773,
	"./SUMICHEM.png": 65710,
	"./SUNDARMFIN.png": 47350,
	"./SUNDRMFAST.png": 97786,
	"./SUNPHARMA.png": 19965,
	"./SUNTV.png": 91376,
	"./SUPREMEIND.png": 44598,
	"./SUZLON.png": 17410,
	"./SWANCORP.png": 44809,
	"./SWIGGY.png": 87204,
	"./SYNGENE.png": 75914,
	"./SYRMA.png": 20016,
	"./TARIL.png": 35947,
	"./TATACHEM.png": 83436,
	"./TATACOMM.png": 5369,
	"./TATACONSUM.png": 20172,
	"./TATAELXSI.png": 65737,
	"./TATAINVEST.png": 59663,
	"./TATAMOTORS.png": 3012,
	"./TATAPOWER.png": 69709,
	"./TATASTEEL.png": 21580,
	"./TATATECH.png": 95548,
	"./TBOTEK.png": 5052,
	"./TCS.png": 19982,
	"./TECHM.png": 33356,
	"./TECHNOE.png": 27217,
	"./TEJASNET.png": 20221,
	"./THELEELA.png": 18933,
	"./THERMAX.png": 63025,
	"./TIINDIA.png": 7423,
	"./TIMKEN.png": 46233,
	"./TITAGARH.png": 56091,
	"./TITAN.png": 31732,
	"./TMPV.png": 13454,
	"./TORNTPHARM.png": 88872,
	"./TORNTPOWER.png": 18974,
	"./TRENT.png": 93912,
	"./TRIDENT.png": 27163,
	"./TRITURBINE.png": 44565,
	"./TRIVENI.png": 13294,
	"./TTML.png": 90872,
	"./TVSMOTOR.png": 38671,
	"./UBL.png": 86939,
	"./UCOBANK.png": 83413,
	"./ULTRACEMCO.png": 60355,
	"./UNIONBANK.png": 74977,
	"./UNITDSPR.png": 67072,
	"./UNOMINDA.png": 11796,
	"./UPL.png": 6962,
	"./USHAMART.png": 29681,
	"./UTIAMC.png": 5054,
	"./VBL.png": 50879,
	"./VEDL.png": 72339,
	"./VENTIVE.png": 25634,
	"./VGUARD.png": 37171,
	"./VIJAYA.png": 14957,
	"./VMM.png": 25869,
	"./VOLTAS.png": 71803,
	"./VTL.png": 43207,
	"./WAAREEENER.png": 83932,
	"./WELCORP.png": 72735,
	"./WELSPUNLIV.png": 65513,
	"./WHIRLPOOL.png": 99953,
	"./WIPRO.png": 1506,
	"./WOCKPHARMA.png": 95009,
	"./YESBANK.png": 88292,
	"./ZEEL.png": 59493,
	"./ZENSARTECH.png": 24353,
	"./ZENTEC.png": 81390,
	"./ZFCVINDIA.png": 47224,
	"./ZYDUSLIFE.png": 78084,
	"./default.png": 88294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69856;